<h1 mat-dialog-title>Alert!!!</h1>
<div mat-dialog-content>{{'Due to inactivity, you will be logout in ' + idleState + ' seconds!'}}</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>